// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login_content[data-v-43fb9bf5] {\n  display: inline-block;\n  width: 2.192708rem;\n  height: 2.364583rem;\n  margin: 0 0.104167rem;\n  background-color: #fff;\n  border-radius: 0.0625rem;\n  z-index: 99;\n  border: 0.005208rem solid #eee;\n}\n.login_content .el-tabs[data-v-43fb9bf5] {\n  width: 80%;\n  margin: 0.260417rem auto;\n}", ""]);
// Exports
module.exports = exports;
